export enum EventDrawerTabs {
  Locations = 'LOCATIONS',
  Participants = 'PARTICIPANTS',
}
